import { get, post } from './http'
import crypt from '../utils/rsa'

/**
 * 获取协议
 * @type {Promise<*>}
 */
export const getAgreement = type => get('/customer/oic/getI18nTranslations', {type})


export const pushIp = data => {
  const encryptedString = crypt.encryptLong(JSON.stringify(data))
  return post(`/customer/oic/guess`, { encryptedString }, { loading: false })
}
